import React, { CSSProperties } from "react";
import { useBeltMarquee, GAP_PX } from "../hooks/useBeltMarquee";

interface BeltTitleProps {
  text: string;
  style?: CSSProperties;
}

// One-line title that scrolls left and WARPS around (Pac-Man style): a second
// copy of the text follows in from the right, so the title loops seamlessly
// rather than bouncing back. All behaviour lives in useBeltMarquee — this is
// pure presentation.
const BeltTitle: React.FC<BeltTitleProps> = ({ text, style }) => {
  const { containerRef, trackRef, copyRef, overflowing } = useBeltMarquee(text);

  return (
    <div ref={containerRef} style={{ overflow: "hidden", whiteSpace: "nowrap" }}>
      <div
        ref={trackRef}
        style={{
          display: "inline-flex",
          whiteSpace: "nowrap",
          // Only promote a compositor layer for titles that actually scroll —
          // a long list of static titles shouldn't each hold a layer.
          willChange: overflowing ? "transform" : "auto",
        }}
      >
        <span ref={copyRef} style={{ ...style, display: "inline-block", flexShrink: 0 }}>
          {text}
        </span>
        {/* Second copy + gap, ONLY when the title overflows — it warps in from
            the right. For titles that fit, there is no 2nd copy at all. */}
        {overflowing && (
          <>
            <span
              aria-hidden
              style={{ display: "inline-block", width: `${GAP_PX}px`, flexShrink: 0 }}
            />
            <span aria-hidden style={{ ...style, display: "inline-block", flexShrink: 0 }}>
              {text}
            </span>
          </>
        )}
      </div>
    </div>
  );
};

export default BeltTitle;
